export type TournamentHostBanner = {
  /** Rendered only on pages whose URL path includes this substring. */
  matchPath: string;
  hostName: string;
  hostUrl: string;
  hostLogo: string;
  /** Completes "Thank you to <hostName> ..." */
  copySuffix: string;
  ctaLabel: string;
};

export const tournamentHostBanners: TournamentHostBanner[] = [
  {
    matchPath: "/tournament/2026-bassmaster-kayak-series-championship/",
    hostName: "Capital City Lake Murray Country",
    hostUrl: "https://www.lakemurraycountry.com/",
    hostLogo:
      "https://www.lakemurraycountry.com/wp-content/themes/blueion/assets/images/logo-rvsd.png",
    copySuffix:
      "for hosting the 2026 Bassmaster Kayak Series Championship on Lake Murray.",
    ctaLabel: "Plan Your Trip to Lake Murray Country",
  },
];

export function findTournamentHostBanner(
  path: string,
): TournamentHostBanner | undefined {
  return tournamentHostBanners.find((banner) => path.includes(banner.matchPath));
}
